// extracted by mini-css-extract-plugin
var _1 = "container--vArd8";
var _2 = "loading--WJst4";
export { _1 as "container", _2 as "loading" }
